var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"calc(100% - 20px)"}},[(_vm.platformApplyAcdPageIndex===1)?_c('platformApplyList'):_vm._e(),(_vm.platformApplyAcdPageIndex===2)?_c('platformAdd'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }